// import './Member.css';
import { useMemo, useState } from 'react';
import { useEffect } from 'react';
import { toast } from 'react-toastify';
import httpClient from '../../HTTPService';
import moment from 'moment';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const ProfileRequestTable = () => {
    const [offsetValue, setoffsetValue] = useState(0);
    const [memberlist, setmemberlist] = useState([]);
    const [originalMemberList, setOriginalMemberList] = useState([])
    const navigate = useNavigate();
    const [searchtext, setsearchtext] = useState('')
    const [totalCount, setTotalCount] = useState(0)
    const [currentPage, setCurrentPage] = useState(1);
    const [getLimit, setLimit] = useState(10);
    const items = Array.from({ length: totalCount }, (_, index) => `Item ${index + 1}`);
    const itemsPerPage = 10;
    const totalPages = Math.ceil(items.length / getLimit);
    const startPage = Math.max(1, currentPage - Math.floor(5 / 2));
    const endPage = Math.min(totalPages, currentPage + Math.floor(5 / 2));
    const [filter, setfilter] = useState(-1)
    let location = useLocation()
    const [setChange, setLimitChange] = useState(false)
    const handlePageChange = (page) => {
        setCurrentPage(page);
        // location  = undefined
    };

    const startIndex = (currentPage - 1) * getLimit;
    const currentItems = items.slice(startIndex, startIndex + getLimit);

    //pagination
    const Pagination = ({ currentPage, totalPages, onPageChange }) => {
        const pages = [];
        for (let i = 1; i <= totalPages; i++) {
            pages.push(i);
        }
        console.log(currentPage, 'current pages...')
        return (
            <div className="pagination">
                {currentPage > 1 && (
                    <button className="pagination-btn" onClick={() => onPageChange(currentPage - 1)}>
                        <i className="fa fa-chevron-left" aria-hidden="true"></i>
                    </button>
                )}
                {startPage > 1 && (
                    <button className="pagination-btn" onClick={() => onPageChange(1)}>
                        1
                    </button>
                )}
                {startPage > 2 && <span className="pagination-ellipsis">...</span>}
                {pages.slice(startPage - 1, endPage).map(page => (
                    <button
                        key={page}
                        className={`pagination-btn ${page === currentPage ? 'active' : ''}`}
                        onClick={() => onPageChange(page)}
                    >
                        {page}
                    </button>
                ))}
                {endPage < totalPages - 1 && <span className="pagination-ellipsis">...</span>}
                {endPage < totalPages && (
                    <button className="pagination-btn" onClick={() => onPageChange(totalPages)}>
                        {totalPages}
                    </button>
                )}
                {currentPage < totalPages && (
                    <button className="pagination-btn" onClick={() => onPageChange(currentPage + 1)}>
                        <i className="fa fa-chevron-right" aria-hidden="true"></i>
                    </button>
                )}
            </div>
        );
    };

    useEffect(() => {

        console.log(location, 'locaton data....//?')
        if (location?.state?.backpagi == undefined) {
            getProfileRequestlist(searchtext, currentPage, getLimit);
        } else if (location?.state?.backpagi != undefined) {
            //    console.log('fkjsdfjskfjskfjsklfjskf')
            setCurrentPage(location?.state?.backpagi?.pageCurrent)
            setLimit(location?.state?.backpagi?.limit)
            getProfileRequestlist(searchtext, location?.state?.backpagi?.pageCurrent, location?.state?.backpagi?.limit)
        }

    }, [currentPage, getLimit, filter]);
    const editItem = (e) => {
        // console.log(e);
        let paginationState = {
            pageCurrent: currentPage,
            limit: getLimit,

        }
        navigate(`/memberprofile-details?id=${e?.id}`, {
            state: {
                paginationState
            }
        });
        //  localStorage.setItem('editSubData',editSub)
    }
    const viewIncome = (e) => {
        let paginationState = {
            pageCurrent: currentPage,
            limit: getLimit,

        }
        navigate(`/memberincome?id=${e?.id}`,
            {
                state: {
                    paginationState
                }
            }

        );
        //  localStorage.setItem('editSubData',editSub)
    }
    const viewTeam = (e) => {
        console.log(e);
        let paginationState = {
            pageCurrent: currentPage,
            limit: getLimit,

        }
        // const editSub = JSON.stringify(e)
        navigate(`/member-teamdetails?id=${e?.id}`,

            {
                state: {
                    paginationState
                }
            }
        );
        //  localStorage.setItem('editSubData',editSub)
    }
    const searchtxt = () => {
        getProfileRequestlist(searchtext, 1, getLimit);
    }

    // view tooltip
    function setTooltipMessage(message) {
        const tooltipBox = document.getElementById('tooltipBox');
        tooltipBox.textContent = message;
    }
    const getProfileRequestlist = async (search_name, pagecount, limit) => {
        try {
            const result = await httpClient.post('/admin/accounts-list', {
                search_name,
                offset: pagecount, limit: limit,
                search_status: filter,
                // search_membership_type: filter
            }, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })

            if (result.status === 200) {
                // location?.state = ''
                // console.log(result.data.data, 'data..')
                // location.state = null
                setTotalCount(result?.data.total_count)
                console.log(result?.data?.data, 'member sli sere')
                setmemberlist(result?.data?.data)
                setChange(false)
            }

        } catch (error) {
            //   toast.error(error.message)
        }
    }

    // filterd data
    useMemo(() => {
        console.log(filter, 'filterd...')


        // if (filter != 3) {
        //     let _filterdata = [...originalMemberList].filter(_fitem => _fitem.active == filter)
        //     console.log(_filterdata, filter, 'filted data..')
        //     setmemberlist(_filterdata)
        // } else if (filter == 3) {
        // //     console.log('set orginal')
        //     setmemberlist(originalMemberList)
        // }
        // getProfileRequestlist()

        return () => { }

    }, [])


    // debounce function to limit the number of API calss
    function debounce(func, delay) {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => func(...args), delay);
        };
    }
    // search handler function
    const searchHandler = debounce((query) => {
        setsearchtext(query);
        getProfileRequestlist(query, 1, getLimit);
    }, 2000)
    return (
        <div className="member">

            <div className=''>

                <div class="search-box">
                    <div class="searchtct ">

                        <i class="fa fa-filter" aria-hidden="true"></i>
                        <select
                            value={filter}
                            // className='ml-3'
                            // disabled={chooseFldType ===     '' ? true : false}
                            onChange={(val) => { setfilter(val.target.value) }}
                        //   className={(isrequired && labelvalue === null) ? 'required' :'' }
                        >
                            <option value={-1} >All</option>

                            <option value={0} >Pending</option>
                            <option value={1}>Approve</option>
                            <option value={2}>Reject</option>
                            <option value={3}>Blocked</option>

                        </select>

                    </div>
                    <div class="searchtct">

                        <i class="fa fa-search" aria-hidden="true"></i>
                        <input type="text" name="text" placeholder="Search..."
                            onChange={(val) => {
                                searchHandler(val?.target?.value, currentPage, getLimit)

                            }
                            }
                        // onKeyDown={() => {
                        //     // if (searchtext === '') {
                        //         searchHandler(searchtext, currentPage, getLimit)
                        //     // }
                        // }}
                        />
                        {/* <button type='button' className='searchBtn' onClick={searchtxt} >Search</button> */}


                    </div>

                </div>
            </div>

            <h4>{
                filter == -1 ? `Total Profile : ${totalCount}` :
                    filter == 0 ? `Total Pending Profile: ${totalCount}` :
                        filter == 1 ? `Total Approve Profile: ${totalCount}` : `Total Reject Profile: ${totalCount}`
            }</h4>
            <div class="row">
                <div class="col-md-12">
                    <div class="table-responsive">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>SL NO</th>
                                    <th> Member Name & ID</th>
                                    <th>Mobile No</th>
                                    {/* <th>Validity</th>
                <th >Description</th> */}
                                    {/* <th>Discount</th>
                <th>Price</th> */}
                                    <th>Category</th>
                                    <th>Sub Category</th>
                                    <th>Pay Amount</th>
                                    <th>Create At</th>
                                    <th>Status</th>
                                    <th>Action</th>


                                </tr>
                            </thead>
                            <tbody>

                                {
                                    memberlist?.map((item, index) => {
                                        const serialNumber = (currentPage - 1) * getLimit + index + 1;
                                        const foundItem = item.get_status?.find(item => item.status == 2);
                                        const pending_item = item.get_status?.find(item => item.status == 0);

                                        return (
                                            <>
                                                <tr>
                                                    <td style={{
                                                        backgroundColor: item?.user?.phone == null ? 'gray' : 'transparent',
                                                        color: item?.user?.phone == null ? 'white' : 'black'
                                                    }}>{serialNumber}</td>
                                                    <td style={{
                                                        backgroundColor: item?.user?.phone == null ? 'gray' : 'transparent',
                                                        color: item?.user?.phone == null ? 'white' : 'black'
                                                    }}>
                                                        <p> {item?.user?.name}</p>
                                                        <p> {item?.user?.user_referral_code} </p>

                                                    </td>
                                                    <td style={{
                                                        backgroundColor: item?.user?.phone == null ? 'gray' : 'transparent',
                                                        color: item?.user?.phone == null ? 'white' : 'black'
                                                    }}>{item?.user?.phone}</td>
                                                    <td style={{
                                                        backgroundColor: item?.user?.phone == null ? 'gray' : 'transparent',
                                                        color: item?.user?.phone == null ? 'white' : 'black'
                                                    }}>
                                                        {item?.category?.name}
                                                    </td>
                                                    <td style={{
                                                        backgroundColor: item?.user?.phone == null ? 'gray' : 'transparent',
                                                        color: item?.user?.phone == null ? 'white' : 'black'
                                                    }}>   {item?.sub_category?.name}</td>
                                                    <td style={{
                                                        backgroundColor: item?.user?.phone == null ? 'gray' : 'transparent',
                                                        color: item?.user?.phone == null ? 'white' : 'black'
                                                    }}>   {item?.first_purchase?.price}</td>

                                                    <td style={{
                                                        backgroundColor: item?.user?.phone == null ? 'gray' : 'transparent',
                                                        color: item?.user?.phone == null ? 'white' : 'black'
                                                    }}>

                                                        <p > {moment(item?.created_at).format('DD-MM-YYYY')} </p>
                                                        <p style={{
                                                            textAlign: 'center',
                                                            margin: 0,
                                                            padding: 0
                                                        }}> {moment(item?.created_at).format('LT')} </p>
                                                        {
                                                            foundItem != undefined && moment(item?.date).format('DD/MM/YYYY') != moment(pending_item?.date).format('DD/MM/YYYY') && <p style={{
                                                                padding: 0,
                                                                margin: 0,
                                                                color: 'red',
                                                                fontWeight: 'bold'
                                                            }}>Send Again</p>


                                                        }
                                                        {
                                                            foundItem != undefined && moment(item?.date).format('DD/MM/YYYY') != moment(pending_item?.date).format('DD/MM/YYYY') && <p style={{
                                                                padding: 0,
                                                                margin: 0
                                                            }}>{moment(pending_item?.date).format('DD/MM/YYYY')}</p>

                                                        }
                                                    </td>

                                                    <td style={{
                                                        backgroundColor: item?.user?.phone == null ? 'gray' : 'transparent',
                                                        color: item?.user?.phone == null ? 'white' : 'black'
                                                    }}>
                                                        {
                                                            item?.get_status != undefined && (
                                                                // item?.get_status?.map((status) => {
                                                                //     return
                                                                <div>

                                                                    <p style={{
                                                                        color: item?.get_status[item?.get_status?.length - 1]?.status == 0 ? '#000000' : item?.get_status[item?.get_status?.length - 1]?.status == 1 ? 'green' : item?.get_status[item?.get_status?.length - 1]?.status == 2 ? 'red' : item?.get_status[item?.get_status?.length - 1]?.status == 3 ? 'red' : ''
                                                                    }}>
                                                                        {item?.get_status[item?.get_status?.length - 1]?.status == 0 ? 'Pending' : item?.get_status[item?.get_status?.length - 1]?.status == 1 ? 'Approve' : item?.get_status[item?.get_status?.length - 1]?.status == 2 ? 'Reject' : item?.get_status[item?.get_status?.length - 1]?.status == 3 ? 'Profile Blocked' : ''}</p>
                                                                    {item?.get_status[item?.get_status?.length - 1]?.status != 0 && <p>{moment(item?.get_status[item?.get_status?.length - 1]?.created_at).format('lll')}</p>}
                                                                </div>
                                                                // })
                                                            )
                                                        }


                                                    </td>
                                                    <td style={{
                                                        backgroundColor: item?.user?.phone == null ? 'gray' : 'transparent',
                                                        color: item?.user?.phone == null ? 'white' : 'black'
                                                    }}>
                                                        <div className='table-column'>
                                                            <i
                                                                onClick={() => navigate(`/profile-request-details/${item?.id}`)}
                                                                class="fa fa-eye" aria-hidden="true"></i>
                                                        </div>

                                                    </td>

                                                </tr>
                                            </>
                                        )
                                    })
                                }

                            </tbody>

                        </table>
                        <div className='nodata-found-div'>
                            {
                                memberlist?.length == 0 ?
                                    <p>No Data Found</p>
                                    //  <img 
                                    //  className='table-image'
                                    //  src={require('../../assets/OIP.png')}/>
                                    : null
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div class="tablepgntn">
                <p>Show <select value={getLimit} onChange={(val) => {
                    setLimit(val.target.value)
                    setCurrentPage(1)
                    // setLimitChange(true)
                }}>
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={30}>30</option>
                    <option value={40}>40</option>
                    <option value={50}>50</option>
                </select> Entries</p>
                <ul>

                </ul>
                <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={handlePageChange}
                />

            </div>

        </div>
    )
}
const boxStyle = {
    width: '200px',
    height: '60px',
    background: '#bbb',
    margin: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '6px',
    cursor: 'pointer'
}
export default ProfileRequestTable;